export default "__VITE_ASSET__DmuU4evG__"